import { layoutSlice } from "./layoutSlice";

const { actions } = layoutSlice;

export const setCallAssetListAPI = payload => dispatch => {
  return dispatch(actions.setCallAssetListAPI(payload));
};

export const setShowNotificationPopper = payload => dispatch => {
  return dispatch(actions.setShowNotificationPopper(payload));
};

export const setPartnerRouteLink = payload => dispatch => {
  return dispatch(actions.setShowNotificationPopper(payload));
};

export const setShowLoginPopper = payload => dispatch => {
  return dispatch(actions.setShowLoginPopper(payload));
};

export const setShowOptionPopper = payload => dispatch => {
  return dispatch(actions.setShowOptionPopper(payload));
};

export const setShowLogin360Popper = payload => dispatch => {
  return dispatch(actions.setShowLogin360Popper(payload));
};

export const setShowGuest360Popper = payload => dispatch => {
  return dispatch(actions.setShowGuest360Popper(payload));
};

export const setShowSignup360Popper = payload => dispatch => {
  return dispatch(actions.setShowSignup360Popper(payload));
};

export const setShowNotLoginPopper = payload => dispatch => {
  return dispatch(actions.setShowNotLoginPopper(payload));
};

export const setShowSignupPopper = payload => dispatch => {
  return dispatch(actions.setShowSignupPopper(payload));
};

export const setGuestID = payload => dispatch => {
  return dispatch(actions.setGuestID(payload));
};

export const setShowOrganizationPopper = payload => dispatch => {
  return dispatch(actions.setShowOrganizationPopper(payload));
};

export const setShowProfilePopper = payload => dispatch => {
  return dispatch(actions.setShowProfilePopper(payload));
};

export const setShowOrgModal = payload => dispatch => {
  return dispatch(actions.setShowOrgModal(payload));
};

export const setCurrentUserData = payload => dispatch => {
  return dispatch(actions.setCurrentUserData(payload));
};

export const setShowUserVerifyStatusModal = payload => dispatch => {
  return dispatch(actions.setShowUserVerifyStatusModal(payload));
};

export const setShowLoginModal = payload => dispatch => {
  return dispatch(actions.setShowLoginModal(payload));
};

export const setShowGuestSignupModal = payload => dispatch => {
  return dispatch(actions.setShowGuestSignupModal(payload));
};

export const setShowSignupModal = payload => dispatch => {
  return dispatch(actions.setShowSignupModal(payload));
};

export const setIsOnAssetPage = payload => dispatch => {
  return dispatch(actions.setIsOnAssetPage(payload));
};

export const setIsShowTNCDialog = payload => dispatch => {
  return dispatch(actions.setIsShowTNCDialog(payload));
};

export const setLoginAction = payload => dispatch => {
  return dispatch(actions.setLoginAction(payload));
};
